import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=a0f37b40&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0f37b40')) {
      api.createRecord('a0f37b40', component.options)
    } else {
      api.reload('a0f37b40', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=a0f37b40&", function () {
      api.rerender('a0f37b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4vB46NYzGL6sF/JS/comp/DateRangeExt.vue"
export default component.exports